export const ChangelogTranslation = {
    previews: [
        {
            id: 'neon',
            image: `${process.env.REACT_APP_CDN_BASE_URL}/changelog/0.0.8/neon.gif`
        },
        {
            id: 'realisticSpace',
            image: `${process.env.REACT_APP_CDN_BASE_URL}/changelog/0.0.8/realistic-space.gif`
        }
    ],
    uk: {
        languageLabel: 'Українська',
        languageSwitcherLabel: 'Мова опису оновлення',
        updateLabel: 'Оновлення',
        title: 'Колесо, яке можна зробити своїм',
        summary: 'Новий редактор зовнішнього вигляду, анімовані теми та яскравіша реакція на перемогу.',
        importantNotesLabel: 'Важливо',
        importantNotes: 'Власні теми зберігаються лише в поточному браузері. Локальні файли не передаються разом із кодом теми.',
        newFeaturesLabel: 'Нове',
        newFeatureTitle: 'Повний редактор вигляду колеса',
        newFeatureSummary: 'Налаштуйте колесо під оформлення стріму або почніть з однієї з готових тем.',
        newFeatures: `
- Додано анімовані теми **Neon** і **Realistic Space**.
- Змінюйте кольори секторів, підписи, межі, роздільники, розмір та анімацію колеса.
- Додавайте власні зображення або відео для рамки, центру, вказівника та окремих секторів.
- Налаштовуйте звуки старту, обертання й перемоги або використовуйте готові звукові пресети.
- Зберігайте власні теми та діліться ними за допомогою коду для копіювання.
        `,
        previews: {
            neon: {
                title: 'Neon',
                alt: 'Анімоване прев’ю колеса в темі Neon'
            },
            realisticSpace: {
                title: 'Realistic Space',
                alt: 'Анімоване прев’ю колеса в темі Realistic Space'
            }
        },
        previewLinkLabel: 'Відкрити GIF у повному розмірі',
        improvementsLabel: 'Покращення',
        improvements: `
- Порядок секторів більше не змінюється під час оновлення даних колеса.
- Перемога тепер супроводжується конфеті та дощем із Twitch-емоутів.
- На головній сторінці та біля колеса час від часу з’являються анімовані Pepe-сцени.
- Вхід через Twitch перенесено до верхньої панелі, щоб він був доступний з будь-якої сторінки.
- Перемикання мови стало плавнішим.
        `,
        bugFixesLabel: 'Виправлення',
        bugFixes: `
- Авторизація надійніше відновлюється після перезавантаження сторінки.
- Виправлено повернення до застосунку після входу через Twitch та додано зрозуміле повідомлення про помилку входу.
- Виправлено помилки й неточності в українських та англійських перекладах.
        `,
        closeLabel: 'Закрити опис оновлення',
        confirmLabel: 'Зрозуміло'
    },
    en: {
        languageLabel: 'English',
        languageSwitcherLabel: 'Update description language',
        updateLabel: 'Update',
        title: 'Make the wheel your own',
        summary: 'A new appearance editor, animated themes, and a more exciting winner reveal.',
        importantNotesLabel: 'Important',
        importantNotes: 'Custom themes are stored only in the current browser. Local files are not included when you share a theme code.',
        newFeaturesLabel: 'New',
        newFeatureTitle: 'A complete wheel appearance editor',
        newFeatureSummary: 'Match the wheel to your stream or start with one of the new built-in themes.',
        newFeatures: `
- Added animated **Neon** and **Realistic Space** themes.
- Customize sector colors, labels, borders, dividers, wheel size, and idle animation.
- Add your own images or videos to the frame, center, pointer, and individual sectors.
- Configure start, spin, and win sounds or use the built-in sound presets.
- Save custom themes and share them with a copyable theme code.
        `,
        previews: {
            neon: {
                title: 'Neon',
                alt: 'Animated preview of the wheel using the Neon theme'
            },
            realisticSpace: {
                title: 'Realistic Space',
                alt: 'Animated preview of the wheel using the Realistic Space theme'
            }
        },
        previewLinkLabel: 'Open the full-size GIF',
        improvementsLabel: 'Improvements',
        improvements: `
- Sector order now stays stable when wheel data is updated.
- Winners are now celebrated with confetti and a shower of Twitch emotes.
- Animated Pepe scenes occasionally appear on the home page and around the wheel.
- Twitch sign-in now lives in the top navigation, so it is available from every page.
- Language switching now feels smoother.
        `,
        bugFixesLabel: 'Fixes',
        bugFixes: `
- Authentication is restored more reliably after a page reload.
- Fixed the return to the app after Twitch sign-in and added a clear sign-in error message.
- Fixed translation errors and inconsistencies in Ukrainian and English.
        `,
        closeLabel: 'Close update details',
        confirmLabel: 'Got it'
    }
};
